export default {
      id: "wb_sunny-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#wb_sunny",
      toString: function () {
        return this.url;
      }
    }